import script from "./BookCover.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookCover.vue?vue&type=script&setup=true&lang=ts"

import "./BookCover.vue?vue&type=style&index=0&id=b7e94614&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7e94614"]])

export default __exports__